import ProspectusCover26 from "../../../../src/images/2026ProspectusCover.jpg";
import * as React from 'react';
export default {
  ProspectusCover26,
  React
};